// Firefox 1.0+
export var isFirefox = typeof InstallTrigger !== 'undefined';

// Internet Explorer 6-11
export var isIE = /*@cc_on!@*/false || !!document.documentMode;

// Edge 20+
export var isEdge = !isIE && !!window.StyleMedia;

// Chrome 1 - 71
export var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

// Blink engine detection
export var isBlink = (isChrome) && !!window.CSS;